import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Banner, Text } from 'pcln-design-system'

import { flyGaLogic } from '../../util/flyGaLogic'

const StyledBanner = styled(Banner)`
  margin-bottom: 8px;
  padding: 8px;
`

class ThrottledTripsBanner extends React.PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      visible: true
    }
  }

  close = () => {
    this.setState({
      visible: false
    })
  }

  render() {
    const { throttledTrips } = this.props
    const showBanner =
      throttledTrips && throttledTrips.length && this.state.visible

    if (showBanner) {
      const items = throttledTrips.map((trip, index) => {
        return (
          <li className='throttled-trip-item' key={index}>
            {trip.throttledTrip}
          </li>
        )
      })

      flyGaLogic.fire.nearbyAirportResult()

      return (
        <StyledBanner
          bg='alert.light'
          iconName={'attention'}
          onClose={this.close}
        >
          <Text mb={1}>
            We were unable to include the following criteria in your search, but
            found many great flights for you, below:
          </Text>
          <ul>{items}</ul>
        </StyledBanner>
      )
    }

    return null
  }
}

ThrottledTripsBanner.propTypes = {
  throttledTrips: PropTypes.array
}

export { ThrottledTripsBanner }
